import { AnswerItem } from "models/AnswerItem";
import iconAnswerCheck from 'assets/icons/answers/icon-answer-check.svg';
import iconAnswerBriefcase from 'assets/icons/answers/icon-answer-briefcase.svg';
import iconAnswerMoney from 'assets/icons/answers/icon-answer-money.svg';
import iconAnswerUser from 'assets/icons/answers/icon-answer-user.svg';

export const REQUIREMENTS_BUYER_ANSWERS: AnswerItem[] = [
	{
		title: 'Renta',
		content: 'Mínimo $600.000',
		icon: iconAnswerMoney,
	},
	{
		title: 'Antigüedad laboral',
		content: 'Mínimo un año o continuidad laboral',
		icon: iconAnswerBriefcase,
	},
	{
		title: 'Edad',
		content: (
			<>
				Mayor de 26 años <p className="small">(Menor de 26 años debe presentar un aval)</p>
			</>
		),
		icon: iconAnswerUser,
	},
	{
		title: 'Comportamiento ',
		content: 'No presentar atrasos ni morosidades',
		icon: iconAnswerCheck,
	},
];
